module.exports = __webpack_public_path__ + "aad0cc156e9929f5a18936ec76b5f6b6.jpg";